(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MetierDetailController', MetierDetailController);

    MetierDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Metier'];

    function MetierDetailController($scope, $rootScope, $stateParams, previousState, entity, Metier) {
        var vm = this;

        vm.metier = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:metierUpdate', function(event, result) {
            vm.metier = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
